module.exports = __webpack_public_path__ + "img/count-down-header.43bd5b3.png";